module.exports = __webpack_public_path__ + "img/logo1.0b777d58.png";